import { render, staticRenderFns } from "./study-participants-edc-data-dashboard.vue?vue&type=template&id=7edda99f&scoped=true&"
import script from "./study-participants-edc-data-dashboard.vue?vue&type=script&lang=js&"
export * from "./study-participants-edc-data-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./study-participants-edc-data-dashboard.vue?vue&type=style&index=0&id=7edda99f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edda99f",
  null
  
)

component.options.__file = "study-participants-edc-data-dashboard.vue"
export default component.exports